<template>
  <div class="alphabet-search" :class="{'alphabet-search--active': chosenLetter}" v-if="letters.length">
    <div class="alphabet-search-content" @click.stop>
      <div class="alphabet-search-letters" :class="{'alphabet-search-letters--wide': !catalogId}">
        <div
            class="alphabet-search-letter"
            :class="{'alphabet-search-letter--chosen': letter === chosenLetter}"
            v-for="letter in letters"
            @click="!mouseBehaviour ? choseLetter(letter) : false"
            @mouseover="!mouseBehaviour ? false : choseLetter(letter)"
        >
          {{ letter }}
        </div>
      </div>
      <div class="alphabet-search-popup" v-if="chosenLetter">
        <transition name="fade">
          <div class="alphabet-search-popup-list" v-if="categories.length">
            <div class="alphabet-search-popup-item" v-for="category in categories">
              <a :href="category.link">
                {{ category.name }}
              </a>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AlphabetSearch',
  props: {
    catalogId: {
      type: Number,
    },
    location: {
      type: String,
      default: 'page',
    }
  },
  data() {
    return {
      letters: [],
      chosenLetter: '',
      categories: [],
      mouseBehaviour: window.innerWidth > 1024 && this.location === 'catalogMenu'
    }
  },
  methods: {
    choseLetter(letter) {
      if (this.chosenLetter === letter) {
        this.chosenLetter = ''
        return
      }

      if (this.location === 'sidebar') {
        const dropdown = document.querySelector(`[data-catalog-dropdown="${ this.catalogId }"]`)
        if (dropdown) {
          const letterSection = dropdown.querySelector(`[data-letter="${ letter }"]`)
          if (letterSection) {
            dropdown.querySelector('.simplebar-scroll-content').scroll({
              top: letterSection.offsetTop,
              behavior: 'smooth'
            })

            return
          }
        }
      }
      else if (this.location === 'menu') {
        const letterSection = this.$root.$el.querySelector(`[data-letter="${ letter }"]`)
        if (letterSection) {
          document.querySelector('.m-dropdown.show.right').scroll({
            top: letterSection.offsetTop,
            behavior: 'smooth'
          })
        }

        return
      }

      this.chosenLetter = letter
      this.categories = []
      this.getCategories()
    },
    getCategories() {
      axios.get(`/api/catalog/alphabet-search/get/${ this.chosenLetter }`, {
        params: {
          catalogId: this.catalogId
        }
      }).then((response) => {
        this.categories = response.data || []
      })
    },
    getLetters() {
      if (this.letters.length) {
        return
      }

      axios.get('/api/catalog/alphabet-search/get-letters', {
        params: {
          catalogId: this.catalogId
        }
      }).then((response) => {
        this.letters = response.data || ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Э', 'Ю', 'Я']
      })
    },
  },
  created() {
    if (this.location !== 'sidebar') {
      this.getLetters()
    }
    else {
      for (const element of document.querySelectorAll('[data-dropdown="catalog-dropdown"] [data-dropdown-list-selector]')) {
        element.addEventListener('click', () => {
          if (element.dataset.dropdownListSelector == this.catalogId) {
            this.getLetters()
          }
        })
      }
    }
  },
  mounted() {
    document.addEventListener('click', () => {
      this.chosenLetter = ''
    })

    if (this.mouseBehaviour) {
      this.$nextTick(() => {
        let element = this.$root.$el;
        if (!element.classList.contains('alphabet-search-root')) {
          element = element.querySelector('.alphabet-search-root')
        }

        if (!element) {
          return
        }

        element.addEventListener('mouseleave', () => this.chosenLetter = '')
      })
    }
  },
  watch: {
    catalogId(newValue, oldValue) {
      if (this.location !== 'sidebar' && newValue != oldValue) {
        this.letters = []
        this.getLetters()
      }
    }
  }
}
</script>
